<div class="flex justify-center" *ngIf="data?.typeMessage">
    <mat-icon [class]="type[data.typeMessage].class" [svgIcon]="type[data.typeMessage].icon"></mat-icon>
</div>

<h1 mat-dialog-title class="text-2xl text-center mb-4 font-bold" *ngIf="data?.title">
    {{ data.title }}
</h1>

<div mat-dialog-content class="text-lg font-medium text-justify mb-4" [ngClass]="{ 'mt-4': !data?.title }">
    <!-- <p class="text-center">{{ data.message }}</p> -->
     <p class="text-center" [innerHTML]="data.message"></p>
</div>

<div mat-dialog-actions class="flex justify-between">
    <button class="filter-button-warn shadow-button px-1 max-w-24" *ngIf="data.showBtnCancel"
        (click)="dialogRef.close(false)">
        <div class="text-small">
            {{ data.cancelText ? data.cancelText : "Cancelar" }}
        </div>

    </button>

    <button [class]="
            data?.typeMessage ? type[data.typeMessage].background : 'filter-button2 shadow-button max-w-24 px-1'
        "  (click)="dialogRef.close(true)">
        <div class="text-small">
            {{ data.submitText ? data.submitText : "Ok" }}
        </div>

    </button>
</div>